/* eslint-disable */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { X, TrendingUp, Gift, Award, Calendar, Loader2 } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HistoryModal = ({ userId, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    axios
      .get(`${API}/user/${userId}/history`)
      .then((r) => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [userId]);

  if (!userId) return null;

  return (
    <div
      className="fixed inset-0 z-[200] bg-black/90 backdrop-blur-sm overflow-y-auto p-4"
      data-testid="history-modal"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="max-w-3xl mx-auto bg-gradient-to-br from-zinc-900 to-emerald-950/40 border-2 border-emerald-500/30 rounded-3xl p-6 my-4 relative">
        <button
          onClick={onClose}
          data-testid="history-close-btn"
          className="absolute top-4 right-4 bg-zinc-800 hover:bg-red-600 text-white p-2 rounded-full"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex items-center gap-3 mb-5">
          <div className="bg-emerald-500/20 p-3 rounded-2xl">
            <TrendingUp className="w-7 h-7 text-emerald-400" />
          </div>
          <div>
            <h2 className="text-white font-black text-2xl">📜 Istori Pèsonèl</h2>
            <p className="text-zinc-500 text-xs">Tout vant ou + pèfòmans depi w sou Vape Yard</p>
          </div>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <Loader2 className="w-8 h-8 animate-spin mx-auto text-emerald-400" />
          </div>
        ) : !data ? (
          <p className="text-zinc-500 text-center py-12">Pa gen done</p>
        ) : (
          <>
            {/* User header */}
            <div className="bg-zinc-900/70 rounded-xl p-4 mb-4 flex items-center justify-between flex-wrap gap-3">
              <div>
                <p className="text-white font-bold text-lg">{data.name}</p>
                <p className="text-zinc-500 text-xs">
                  {data.role === "network_marketer" ? "🌐 Network Marketer" : data.role === "manager" ? "👔 Manager" : data.role === "inv" ? "💰 Investisseur" : "📦 Stocker"} • Kòd: {data.code} •{" "}
                  {(data.country || "").toUpperCase()}
                </p>
                {data.converted_from && (
                  <p className="text-amber-300 text-[10px] mt-1">
                    🔄 Konvèti depi {data.converted_from === "stocker" ? "Stocker" : "Network Marketer"} sou{" "}
                    {new Date(data.conversion_date).toLocaleDateString("fr-FR")}
                  </p>
                )}
              </div>
              <div className="text-right">
                <p className="text-zinc-500 text-[10px] uppercase">Pousantaj sik aktyèl</p>
                <p
                  className="text-3xl font-black"
                  style={{ color: data.cycle_pct >= 75 ? "#10b981" : data.cycle_pct >= 40 ? "#f59e0b" : "#ef4444" }}
                >
                  {data.cycle_pct}%
                </p>
              </div>
            </div>

            {/* KPIs */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
              <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-3 text-center">
                <p className="text-blue-400 text-[10px] uppercase">Lifetime Vann</p>
                <p className="text-white font-bold text-2xl" data-testid="history-lifetime-sold">
                  {data.lifetime_sold}
                </p>
              </div>
              <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-xl p-3 text-center">
                <p className="text-yellow-400 text-[10px] uppercase">Lifetime Revni</p>
                <p className="text-yellow-400 font-bold text-2xl">${(data.lifetime_revenue || 0).toFixed(0)}</p>
              </div>
              <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-xl p-3 text-center">
                <p className="text-emerald-400 text-[10px] uppercase">Vant Sik Aktyèl</p>
                <p className="text-emerald-400 font-bold text-2xl">{data.cycle_sold}</p>
              </div>
              <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-3 text-center">
                <p className="text-amber-400 text-[10px] uppercase">Stock Aktyèl</p>
                <p className="text-amber-400 font-bold text-2xl">
                  {data.cycle_current}/{data.cycle_initial}
                </p>
              </div>
            </div>

            {/* Gift / Cadeaux preserved */}
            <div className="bg-gradient-to-br from-amber-950/40 to-purple-950/40 border border-amber-500/30 rounded-xl p-4 mb-5">
              <p className="text-amber-300 text-sm font-bold flex items-center gap-2 mb-2">
                <Gift className="w-4 h-4" /> 🎁 Cadeaux ki Dekoche
              </p>
              <div className="grid grid-cols-2 gap-3">
                <div
                  className={`rounded-lg p-3 ${
                    data.gift_100_unlocked
                      ? "bg-emerald-500/20 border border-emerald-500/40"
                      : "bg-zinc-800/50 border border-zinc-700"
                  }`}
                  data-testid="gift-100-status"
                >
                  <p className="text-white font-bold text-sm">100 Vape Vann</p>
                  <p className={`text-xs mt-1 ${data.gift_100_unlocked ? "text-emerald-400" : "text-zinc-500"}`}>
                    {data.gift_claimed_100 ? "✅ Reklame" : data.gift_100_unlocked ? "🎉 Dekoche" : `${100 - data.lifetime_sold} vape rete`}
                  </p>
                </div>
                <div
                  className={`rounded-lg p-3 ${
                    data.gift_150_unlocked
                      ? "bg-purple-500/20 border border-purple-500/40"
                      : "bg-zinc-800/50 border border-zinc-700"
                  }`}
                  data-testid="gift-150-status"
                >
                  <p className="text-white font-bold text-sm">150 Vape Vann</p>
                  <p className={`text-xs mt-1 ${data.gift_150_unlocked ? "text-purple-400" : "text-zinc-500"}`}>
                    {data.gift_claimed_150 ? "✅ Reklame" : data.gift_150_unlocked ? "🎉 Dekoche" : `${150 - data.lifetime_sold} vape rete`}
                  </p>
                </div>
              </div>
              {data.next_gift_at && (
                <p className="text-amber-200 text-[11px] mt-2 text-center">
                  ⏭️ Pwochen cadeaux a {data.next_gift_at} vape — {data.vapes_to_next_gift} vape rete
                </p>
              )}
            </div>

            {/* Monthly performance */}
            {data.monthly?.length > 0 && (
              <div className="bg-zinc-900/60 rounded-xl p-4 mb-5">
                <p className="text-white font-bold mb-3 flex items-center gap-2 text-sm">
                  <Calendar className="w-4 h-4" /> Pèfòmans pa Mwa
                </p>
                <div style={{ width: "100%", height: 220 }}>
                  <ResponsiveContainer>
                    <BarChart data={data.monthly}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#27272a" />
                      <XAxis dataKey="month" stroke="#9ca3af" />
                      <YAxis stroke="#9ca3af" />
                      <Tooltip contentStyle={{ background: "#18181b", border: "1px solid #3f3f46" }} />
                      <Bar dataKey="qty" name="Vape vann" fill="#10b981" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            )}

            {/* Recent sales */}
            {data.recent_sales?.length > 0 && (
              <div className="bg-zinc-900/60 rounded-xl p-4 mb-4">
                <p className="text-white font-bold mb-2 text-sm">📋 30 Dènye Vant</p>
                <div className="space-y-1 max-h-[280px] overflow-y-auto">
                  {data.recent_sales.map((s, i) => (
                    <div key={i} className="bg-zinc-950/60 p-2 rounded-lg flex items-center justify-between text-xs">
                      <span className="text-white truncate">{s.vape_model}</span>
                      <span className="text-emerald-400 font-bold">+{s.quantity_sold}</span>
                      <span className="text-yellow-400">${((s.quantity_sold || 0) * (s.price_per_unit || 0)).toFixed(2)}</span>
                      <span className="text-zinc-500">{new Date(s.recorded_at).toLocaleDateString("fr-FR")}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Recent withdrawals */}
            {data.recent_withdrawals?.length > 0 && (
              <div className="bg-emerald-950/30 border border-emerald-700/40 rounded-xl p-4 mb-4" data-testid="history-withdrawals">
                <p className="text-emerald-300 font-bold mb-2 text-sm flex items-center gap-2">💰 Istori Retrait Lajan ({data.recent_withdrawals.length})</p>
                <div className="space-y-1 max-h-[240px] overflow-y-auto">
                  {data.recent_withdrawals.map((w, i) => (
                    <div key={i} className="bg-zinc-950/60 p-2 rounded-lg flex items-center justify-between text-xs" data-testid={`withdrawal-row-${i}`}>
                      <span className="text-emerald-300 font-bold">${(w.amount || w.total || 0).toFixed(2)}</span>
                      <span className="text-zinc-400">{w.phone_number || w.phone || "—"}</span>
                      <span className={`text-[10px] font-bold px-2 py-0.5 rounded ${w.status === "paid" || w.paid ? "bg-emerald-500/20 text-emerald-300" : "bg-amber-500/20 text-amber-300"}`}>
                        {w.status === "paid" || w.paid ? "✅ PEYE" : "⏳ AP TANN"}
                      </span>
                      <span className="text-zinc-500">{w.date ? new Date(w.date).toLocaleDateString("fr-FR") : "—"}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Recent stock renewals */}
            {data.recent_renewals?.length > 0 && (
              <div className="bg-blue-950/30 border border-blue-700/40 rounded-xl p-4" data-testid="history-renewals">
                <p className="text-blue-300 font-bold mb-2 text-sm flex items-center gap-2">📦 Istori Renouvèlman Stock ({data.recent_renewals.length})</p>
                <div className="space-y-1 max-h-[240px] overflow-y-auto">
                  {data.recent_renewals.map((r, i) => (
                    <div key={i} className="bg-zinc-950/60 p-2 rounded-lg flex items-center justify-between text-xs" data-testid={`renewal-row-${i}`}>
                      <span className="text-blue-300 font-bold">+{r.quantity || r.stock || 0} vape</span>
                      <span className="text-zinc-400">{r.reason || r.note || "—"}</span>
                      <span className="text-zinc-500">{r.date ? new Date(r.date).toLocaleDateString("fr-FR") : "—"}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default HistoryModal;
